import {useContext} from 'react';
import {DebugModeContext} from './DebugModeProvider';

const useDebugModeContext = () => {
  return useContext(DebugModeContext);
};

export default useDebugModeContext;
